import { useState } from "react";
import "./ForgotPassword.css";
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function ForgotPassword(){
  const { user, token, logout } = useAuth();
  const [email, setEmail] = useState("");
  const REACT_APP_API_URL = process.env.REACT_APP_API_BASE_URL_AUTH;

  const handleSubmit = async (e) => {
    e.preventDefault();
     

    try {
      const response = await fetch(`${REACT_APP_API_URL}/Auth/forgot-password`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
         },
        body: JSON.stringify({
          email: email
        }),
      });

      if (!response.ok) throw new Error("Failed send email address");

      alert("Email address sent successfully!");
    } catch (err) {
      console.error(err.message);
      alert("Error adding sending email address: " + err.message);
    }
  };

  return(
    <div className="forgot-password-wrapper">
      <div className="forgot-password-container">
        <form className="forgot-password-form" onSubmit={handleSubmit}>
          <h2>Forgot password?</h2>
          <p>Enter the email you use to login.</p>
          <div className="form-group">
            <input
              type="email"
              id="email"
              placeholder=" "
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="email">Email Address</label>
          </div>
          <button type="submit">Send Reset Link</button>
          <div className="login-link"><Link to="/login">Back to login</Link></div>
        </form>
      </div>
    </div>
  );
}